import type { User } from 'firebase/auth'
import { UserRole } from '../../../pure-js/types/User'

export type PortalTokenClaims = {
  portalUser?: boolean
  enrollmentUserId?: string
}

export type PortalUser = {
  uid: string
  phone?: string
  enrollmentUserId: string
  name?: string
  email?: string
}

export const needsPortalClaimsSync = (claims: PortalTokenClaims): boolean => {
  if (claims.portalUser !== true) {
    return true
  }
  const enrollmentUserId = getEnrollmentUserIdFromClaims(claims)
  return enrollmentUserId === null
}

export const getEnrollmentUserIdFromClaims = (claims: PortalTokenClaims): string | null => {
  const raw = claims.enrollmentUserId
  if (typeof raw !== 'string') {
    return null
  }
  const trimmed = raw.trim()
  return trimmed.length > 0 ? trimmed : null
}

export const hasSuperAdminRole = (claims: { roles?: unknown }): boolean => {
  return Array.isArray(claims.roles) && claims.roles.includes(UserRole.SuperAdmin)
}

/** Landing page owns the custom-token hop; do not treat this user as a portal customer yet. */
export const shouldHoldPortalAuthForViewAsHop = (isSuperAdmin: boolean, pendingTicketId: string | null): boolean =>
  !isSuperAdmin && !!pendingTicketId

export const canAccessProtectedPortal = (portalUser: { uid: string } | null): boolean => portalUser !== null

export const buildPortalUser = (firebaseUser: User, enrollmentUserId: string): PortalUser => {
  if (!firebaseUser.phoneNumber && !firebaseUser.email) {
    throw new Error('buildPortalUser: Firebase user has no phone number or email')
  }

  return {
    uid: firebaseUser.uid,
    phone: firebaseUser.phoneNumber ?? undefined,
    email: firebaseUser.email ?? undefined,
    enrollmentUserId
  }
}
